import styled from 'styled-components';

export const StyledComment = styled.p`
  white-space: pre-wrap;
`;
